import { render, staticRenderFns } from "./form.vue?vue&type=template&id=e1442bec&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=e1442bec&prod&lang=css"
import style1 from "./form.vue?vue&type=style&index=1&id=e1442bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1442bec",
  null
  
)

export default component.exports